import { Col, Row, Space, Tooltip } from "antd";
import React, { Fragment, useEffect, useRef, useState } from "react";

import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";
import { ChatState } from "../../../../base/models/model";
import DialpadDtmf from "../transferKeypad/dialpadNumberdtmf";
import { GetItemFromStorage, SetItemInStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import Lottie from "lottie-react";
import { WtButton } from "../../Button/button";
import _ from "lodash";
import callChatService from "../../../../base/service/chatService";
import { CallSDK } from "unifiedring-sdk";
import { dispositionSliceActions } from "../../../../store/slices/dispositionSlice/postDisposition";
import groovyWalkAnimation from "../../../../styles/images/br-login-animated-dots-black.json";
import styles from "./agentcallAttended.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import userImg from "../../../../styles/images/callGreenRound.svg";
import callPopup from "../../../../styles/images/calliconPopup.png";

import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import { AgentStateAction } from "../../../../store/slices/agent-status/agent_state";
import presenceService from "../../../../base/service/presence";
import store from "../../../../store/redux-store/root_store";
import { hassAccess, summarySubjectHandlerForCall } from "../../../../base/utils";
let { CallUnHold } = CallSDK.Call;
let InterValData: any;
function AgentCallAttended() {
  const planId: any = GetItemFromStorage(LocalStorage.PLAN_ID);
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  let { storeIntentForClearTimer, currentSession, callSessionId, incomingcallDetails }: any = chatReducer;
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const navigate = useNavigate();
  const dispatch = useDispatcher();
  let { dialPadChanges, CallHoldFunction, CallUnHoldFunction, EndCallfunction, CallMuteFunction, CallUnMuteFunction } = CallService(dispatch, navigate);
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  const { dialedNumber, callDetails, incomingCallDetail, sessionIDStore, queueName, opendtmf, isTransferSuccess } = popUpDetails;
  const dispositionData: any = useSelector((state: any) => state.dispositionData);
  let { started, storeInterval } = dispositionData;
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const [openCloseIcon, setOpenCloseIcon] = useState(false);
  const { dispositionTagList } = useSelector((state: any) => state.contactListForAgent);
  const campaign: any = useSelector((state: any) => state.outboundcampaign)
  const HoldFunction = () => {
    console.log("HoldFunction>>>>>>>", incomingCallDetail)
    CallHoldFunction(incomingCallDetail);
  };
  const MuteFunction = () => {
    CallMuteFunction(incomingCallDetail);
  };
  const UnMuteFunction = () => {
    CallUnMuteFunction(incomingCallDetail);
  };
  const UnHoldFunction = () => {
    console.log("UnHoldFunction>>>>>>>", incomingCallDetail)
    CallUnHoldFunction(incomingCallDetail);
  };

  const openDialPadInCall = () => {
    dialPadChanges(false, true, true, false, false, false);
    dispatch(CallPopUpAgentActions.clearDialedNumber());
    if (opendtmf) {
      dispatch(CallPopUpAgentActions.openDFMF())
    }
  };
  const opendtmfInCall = () => {
    dispatch(CallPopUpAgentActions.openDFMF())
  }

  const endCall = () => {
    const ringer: any = document.getElementById("ringer");
    if (incomingCallDetail.callStatus === "Ringing") {

      dispatch(CallPopUpAgentActions.setCallingval(false))
      if (!isTransferSuccess) {
        dispatch(CallPopUpAgentActions.setMergerTransfer())
      }

      let index = _.findIndex(callDetails, (ele: any) => {
        return ele.guid === incomingCallDetail.guid;
      });
      if (index > -1) {
        let endCallDetail = callDetails[index];
        if (endCallDetail.isCurrent === true) {
          EndCallfunction(incomingCallDetail);
          if (endCallDetail.typeOf === "EXTERNAL") {
            dispatch(CallPopUpAgentActions.chatTransferSuccess())
            dialPadChanges(false, false, false, false, false, false);
            // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
            hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch,0)
            dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
          }
        } else {
          EndCallfunction(endCallDetail);
        }
      } else {
        EndCallfunction(incomingCallDetail);
      }
      console.log("callDetails incomingCallDetail>>>>>>>>>>>>>>>>>>>>>>", incomingCallDetail)
      dispatch(CallPopUpAgentActions.removeLastCallDetails())
      dispatch(CallPopUpAgentActions.setTransferFrom([]))
      dispatch(CallPopUpAgentActions.setTransferReset())
      return;
    }
    if (incomingCallDetail.callStatus === "Dialing") {

      ringer.pause();
      if (callDetails.length >= 2 && incomingCallDetail.bound === "OUT") {
        console.log("end call here");
        CallUnHold(callDetails[callDetails.length - 2].useragent);
        dispatch(CallPopUpAgentActions.setSpliceCallDetails(incomingCallDetail.guid));
        EndCallfunction(incomingCallDetail);
      } else if (incomingCallDetail.bound === "OUT" && callDetails.length === 1) {
        EndCallfunction(incomingCallDetail);
        dispatch(CallPopUpAgentActions.setSpliceCallDetails(incomingCallDetail.guid));
      }
    } else {
      // clearInterval(storeIntentForClearTimer);
      if (incomingCallDetail.typeOf === "EXTERNAL") {
        console.log("calling............", incomingCallDetail);
        if (!started) {
          clearInterval(storeInterval);
          InterValData = setInterval(() => {
            dispatch(dispositionSliceActions.startDispositionTimer());
          }, 1000);
          dispatch(dispositionSliceActions.storeIntervalData(InterValData));
        }
        // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
        hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch ,0)
        dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
      } else if (incomingCallDetail.typeOf === "AGENT") {
        // Agent B - tranfer hang up updated on 05/10/2023
        if (incomingCallDetail?.bound === "OUT" && incomingCallDetail?.agentType === "PRIMARY") {
          console.log(" callDetails incomingCallDetail", incomingCallDetail)
          // dispatch(CallPopUpAgentActions.closeTransfer());
          dialPadChanges(false, false, false, false, false, false)
          dispatch(CallPopUpAgentActions.setEndTransferData())
          // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: false }));
          dispatch(CallPopUpAgentActions.setTransferFrom([]))
          dispatch(CallPopUpAgentActions.setTransferReset())
        } else {
          // dispatch(dispositionSliceActions.setDispositionOpen({ isOpenDisPositionStatus: true }));
          hassAccess('Disposition/regenerate') && summarySubjectHandlerForCall(callSessionId, dispatch,0)
          dispatch(ChatActions.setCallSessionList({ state: true, sessionId: callSessionId ?? "" }));
          const { agentStatus } = store.getState().agentState;
          const { users } = store.getState().userList;
          let status: any = null
          if (agentStatus?.length > 0) {
            [status] = agentStatus.filter((i: any) => { return "Busy" === i?.statusName?.trim() })
          }
          let enableStatus: any = null
          if (users.length > 0) {
            [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
          }
          console.log('presenceService 13', status, enableStatus);
          presenceService?.io?.emit("updatestate_backend", {
            domainId: userDetails?.domainId,
            isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
            isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
            isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
            isChatTransfer: status?.isChatTransfer ?? 0,
            isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
            isEmailTransfer: status?.isEmailTransfer ?? 0,
            stateTime: Math.floor(Date.now() / 1000),
            statusName: "Not Ready",
            ext: userDetails?.ext,
            email: userDetails?.Email,
            userId: LoginCcaasUserDetails?.UserID,
            routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
            userName: LoginCcaasUserDetails?.UserName,
            roleId: LoginCcaasUserDetails?.roleid,
            agentStatus: 0,
            skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
            routingMethod: enableStatus?.routingMethod ?? 0,
            inboundCall: enableStatus?.inboundCall,
            outboundCampaignCall: enableStatus?.outboundCampaignCall,
            is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
          });
        }
      }
      let index = _.findIndex(callDetails, (ele: any) => {
        return ele?.guid === incomingCallDetail?.guid;
      });
      if (index > -1) {
        let endCallDetail = callDetails[index];
        console.log('endCallDetail---', endCallDetail)
        if (endCallDetail.isCurrent === true) {
          EndCallfunction(incomingCallDetail);
        } else {
          EndCallfunction(endCallDetail);
        }
      } else {
        EndCallfunction(incomingCallDetail);
      }
    }
    dispatch(CallPopUpAgentActions.cleartimer())
  };

  //action: 1 - merge, 2 - transfer, 3 - cancel, 4 - agent1leavecall, 5 - agent1endforall, 6 - agent2leavecall

  const mergeCall = () => {
    let transferData: any = {
      session_id: sessionIDStore,
      req_type: "TRANSFER_ACTION",
      action: 1,
      ddi: parseInt(dialedNumber),
    };
    callChatService.io.emit("init_transfer", transferData);
    dispatch(CallPopUpAgentActions.closeMergeButton());
  };

  const TransferCall = () => {
    SetItemInStorage("transfer_call", "1");
    let transferData: any = {
      session_id: chatReducer?.currentSession?.sessionId,
      req_type: "TRANSFER_ACTION",
      action: 2,
      ddi: parseInt(dialedNumber),
    };
    callChatService.transfer(transferData);
    let userData: any = userDetails;
    let transferExt = `${userData?.domainId}_${dialedNumber}`;
    callChatService.postTransferData(transferExt);
    dispatch(ChatActions.agentWorkSpaceTansferHistory(popUpDetails?.transferTo));
    dispatch(CallPopUpAgentActions.TransferSuccess());
    const dis = dispositionTagList?.find((i: { dispositionName: any; }) => i.dispositionName === 'Transferred')
    dispatch(dispositionSliceActions.setDisposition({ key: dis }));
  };

  const cancelCall = () => {
    const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
    const LoginUserDetails: any = userDetails;
    if (callDetails.length > 1) {
      let transferData: any = {
        session_id: chatReducer?.currentSession?.sessionId,
        req_type: "TRANSFER_ACTION",
        action: 3,
        ddi: parseInt(dialedNumber),
      };
      callChatService.transfer(transferData);
      endCall();
    } else {
      endCall();

    }
    dispatch(CallPopUpAgentActions.clearDialedNumber());
    const { agentStatus } = store.getState().agentState;
    const { users } = store.getState().userList;
    let status: any = null
    if (agentStatus?.length > 0) {
      [status] = agentStatus.filter((i: any) => { return "Busy" === i?.statusName?.trim() })
    }
    let enableStatus: any = null
    if (users.length > 0) {
      [enableStatus] = users?.filter((i: any) => { return LoginCcaasUserDetails?.emailId === i?.emailId })
    }
    console.log('presenceService 14', status, enableStatus);
    if (callDetails?.length <= 1 || !incomingCallDetail) {
      presenceService?.io?.emit("updatestate_backend", {
        domainId: LoginUserDetails?.domainId,
        isVoice: (enableStatus?.voice === 1 && status?.isVoice === 1) ? 1 : 0,
        isVoiceCallTransfer: status?.isVoiceCallTransfer ?? 0,
        isChat: (enableStatus?.chat === 1 && status?.isChat === 1) ? 1 : 0,
        isChatTransfer: status?.isChatTransfer ?? 0,
        isEmail: (enableStatus?.email === 1 && status?.isEmail === 1) ? 1 : 0,
        isEmailTransfer: status?.isEmailTransfer ?? 0,
        stateTime: Math.floor(Date.now() / 1000),
        statusName: "Not Ready",
        ext: LoginUserDetails?.ext,
        email: LoginUserDetails?.Email,
        agentStatus: 0,
        userId: LoginCcaasUserDetails?.UserID,
        routingProfileId: LoginCcaasUserDetails?.routing_profile_id,
        roleId: LoginCcaasUserDetails?.roleid,
        skill: JSON.parse(enableStatus?.addSkill ?? '[]'),
        routingMethod: enableStatus?.routingMethod ?? 0,
        inboundCall: enableStatus?.inboundCall,
        outboundCampaignCall: enableStatus?.outboundCampaignCall,
        is_outbound_campaign_specific_agent: enableStatus?.is_outbound_campaign_specific_agent
      });
    }
  };

  const leaveCallSecondary = () => {
    let transferData: any = {
      session_id: incomingCallDetail?.sessionId,
      req_type: "TRANSFER_ACTION",
      action: 6,
      ddi: parseInt(userDetails.ext),
      agentType: incomingCallDetail.agentType,
    };
    callChatService.transfer(transferData);
    let userData: any = userDetails;
    let mergeData = {
      ext: incomingCallDetail.AllAgent,
      domainWithExt: incomingCallDetail.AllAgentWithDomainId,
      session_id: chatReducer?.currentSession?.sessionId,
      endBy: userDetails.ext.toString(),
      domainId: userData?.domainId,
      agentType: incomingCallDetail.agentType,
    };
    callChatService.io.emit("leave_call_Secondary", mergeData);

  };

  const leaveCallFromGroup = () => {
    let transferData: any = {
      session_id: chatReducer?.currentSession?.sessionId,
      req_type: "TRANSFER_ACTION",
      action: 4,
      ddi: parseInt(userDetails.ext),
      agentType: incomingCallDetail.agentType,
    };
    callChatService.transfer(transferData);
    let userData: any = userDetails;
    let mergeData = {
      ext: incomingCallDetail.AllAgent,
      session_id: chatReducer?.currentSession?.sessionId,
      endBy: userDetails.ext.toString(),
      domainId: userData?.domainId,
      agentType: incomingCallDetail.agentType,
    };
    callChatService.io.emit("leave_call_primary", mergeData);

  };

  const endForAll = () => {
    let transferData: any = {
      session_id: chatReducer?.currentSession?.sessionId,
      req_type: "TRANSFER_ACTION",
      action: 5,
      ddi: parseInt(userDetails.ext),
    };
    callChatService.transfer(transferData);
    dispatch(CallPopUpAgentActions.endForAll());

    //closemergedCall
  };
  if (chatReducer.transferDetails.length === 0) {
    dispatch(ChatActions.insertTransferDetails(callDetails));
  }

  const closeDialPad = () => {
    dispatch(CallPopUpAgentActions.closeTransfer())
  }

  const [audioOutputDevices, setAudioOutputDevices] = useState<MediaDeviceInfo[]>([]);
  const [audioInputDevices, setAudioInputDevices] = useState<MediaDeviceInfo[]>([]);
  const [changeToSpeaker, setChangeToSpeaker] = useState(false)

  useEffect(() => {
    fetchDevices();
  }, []);

  const [showCancelDialing, setShowCancelDialing] = useState(false);
  const showCancelDialingTimerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    if (showCancelDialingTimerRef.current) {
      clearTimeout(showCancelDialingTimerRef.current);
      showCancelDialingTimerRef.current = null;
    }
  
    if (incomingCallDetail?.callStatus === "Dialing") {
      setShowCancelDialing(false);
      showCancelDialingTimerRef.current = setTimeout(() => {
        setShowCancelDialing(true);
      }, 15000); // 15 seconds
    } else {
      setShowCancelDialing(false);
    }

    return () => {
      if (showCancelDialingTimerRef.current) {
        clearTimeout(showCancelDialingTimerRef.current);
        showCancelDialingTimerRef.current = null;
      }
    };

  }, [incomingCallDetail?.callStatus]);


  const fetchDevices = async () => {
    try {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const outputDevices = devices.filter(device => device.kind === 'audiooutput');
      const inputDevices = devices.filter(device => device.kind === 'audioinput');
      setAudioOutputDevices(outputDevices);
      setAudioInputDevices(inputDevices);
      console.log('Available audio output devices:', outputDevices);
      console.log('Available audio input devices:', inputDevices);
      // Save default audio output device (can use 'default' or first output)
      const defaultOutput = outputDevices.find(dev => dev.deviceId === 'default') || outputDevices[0];
      if (defaultOutput) resetAudioOutput(defaultOutput.deviceId);
    } catch (err) {
      console.error('Error enumerating devices:', err);
    }
  };

  const resetAudioOutput = async (deviceId: any) => {
    const remoteVideo: any = document.getElementById("remoteVideo");
    if (remoteVideo && remoteVideo.setSinkId && deviceId) {
      try {
        await remoteVideo.setSinkId(deviceId);
        console.log(`Audio output reset to default device: ${deviceId}`);
      } catch (err) {
        console.error('Error resetting audio output device:', err);
      }
    }
  };

  const toggleAudioOutput = async (changeState: any) => {
    try {
      setChangeToSpeaker(changeState)
      let remoteVideo: any = document.getElementById("remoteVideo");
      if (!remoteVideo) {
        console.error('Audio element not found');
        return;
      }

      await fetchDevices();

      const callLoginUserAgent: any = store.getState().callLoginUserAgent;
      let { userAgent } = callLoginUserAgent;
      if (audioInputDevices.length > 0 && audioOutputDevices.length > 0) {
        const mic = audioInputDevices.filter((i: any) => i.deviceId === 'communications');
        let selectedDeviceId: any = mic.length > 0 ? mic?.[0]?.deviceId : null
        if (changeState) {
          const com = audioOutputDevices.filter((i: any) => i.deviceId === 'communications');
          const speaker = audioOutputDevices.filter((i: any) => i.groupId !== com?.[0]?.groupId)
          selectedDeviceId = speaker.length > 0 ? speaker?.[0]?.deviceId : null;
        }

        if (selectedDeviceId) {
          if (remoteVideo.setSinkId) {
            await remoteVideo.setSinkId(selectedDeviceId);
            let remoteStream = new MediaStream();
            var pc = userAgent.configuration.sessionDescriptionHandlerFactoryOptions.peerConnectionOptions;
            if (pc.getReceivers) {
              pc.getReceivers().forEach(function (receiver: any) {
                var track = receiver.track;
                if (track) {
                  remoteStream.addTrack(track);
                }
              });
              remoteVideo.srcObject = remoteStream;
            }


            console.log(`Audio output device set to: ${selectedDeviceId}`);

            remoteVideo.volume = 1;
            remoteVideo.muted = false;
            await remoteVideo.play();
            console.log('Audio playback started.');
          } else {
            console.error('setSinkId is not supported in this browser.');
          }
        } else {
          console.error('No audio output devices found');
        }
      } else {
        console.error('No audio devices found');
      }
    } catch (err) {
      console.error('Error toggling audio output device:', err);
    }
  };
  return (
    <>
      <div className={`${styles.callcontainartopsec}`} onMouseOver={() => { setOpenCloseIcon(true) }} onMouseLeave={() => { setOpenCloseIcon(false) }}>
        <p className={`${styles.closeview}`}>
          {openCloseIcon && <span className={`icon__closeiconblack24`} onClick={closeDialPad}></span>}
        </p>



        {!opendtmf && incomingCallDetail.isConference && !incomingCallDetail?.outboundCampaign && (
          <>
            <span className={styles.conference}>Conference Call</span>
            <div className={`${styles.agentsList} ${styles.agentsListdetail}`}>
              {/* <div className={`${styles.users} ${styles.onHold}`}>
            <div className={styles.userDetails}>
              <span className={styles.agentName}>Elumalai</span>
              <span className={styles.agentNumber}>(+44) 2345432341</span>
            </div>
            <div className={styles.callStatus}>
              <div className={styles.hold}><span className="icon__Pause16"></span></div>
            </div>
          </div> */}
              {Array.isArray(incomingCallDetail?.contact) &&
                incomingCallDetail?.contact?.map((contact: any, idx: any) => {
                  return (
                    <Fragment key={idx}>
                      <div className={styles.users}>
                        <div className={styles.userDetails}>
                          <span className={styles.agentName}>
                            {contact?.isCustomer
                              ? contact?.contactDetails?.firstName !== ""
                                ? `${contact?.contactDetails?.firstName} (customer)`
                                : "New Customer"
                              : contact?.contactDetails?.hasOwnProperty("UserName")
                                ? contact?.to !== userDetails?.ext?.toString()
                                  ? contact?.contactDetails?.UserName
                                  : `${contact?.contactDetails?.UserName} (me)`
                                : contact?.to}
                          </span>
                          {/* <span className={styles.agentNumber}>{contact?.isCustomer ? contact?.from : contact?.to}</span> */}
                        </div>
                      </div>

                    </Fragment>
                  );
                })}
            </div>
          </>
        )}

        {!opendtmf && callDetails?.length > 1 && !incomingCallDetail?.outboundCampaign && (
          <div className={styles.agentsList}>
            {Array.isArray(callDetails) &&
              callDetails.map((contact: any, idx: any) => {
                return (
                  <Fragment key={idx}>
                    <div className={styles.users}>
                      <div className={styles.userDetails}>
                        {/* <span className={styles.agentName}>
                          {contact?.isCustomer
                            ? contact?.contactDetails?.firstName !== ""
                              ? contact?.contactDetails?.firstName
                              : "New Customer"
                            : contact?.contactDetails?.hasOwnProperty("name")
                              ? contact?.from !== userDetails?.ext?.toString()
                                ? contact?.contactDetails?.name
                                : `${contact?.contactDetails?.name}(me)`
                              : contact?.from}
                        </span> */}
                        <span className={styles.agentNumber}>{contact?.contactDetails?.firstName !== ""
                              ? contact?.contactDetails?.firstName
                              : "New Customer"}</span>
                        {/* <span className={styles.agentNumber}>{contact.from}</span> */}
                      </div>

                      <div className={styles.callStatus}>
                        {contact.holdState && contact?.callStatus === "accepted" &&  (
                          <div className={styles.hold}>
                            <span className="icon__Pause16"></span>
                          </div>
                        ) 
                        // : (
                        //   <p className={styles.loadingIcon}>
                        //     <Lottie style={{ width: 50, margin: "0 auto" }} animationData={groovyWalkAnimation} />
                        //   </p>
                        // )
                        }
                      </div>
                    </div>
                    ;
                  </Fragment>
                );
              })}
          </div>
        )}
        
        {!opendtmf && !incomingCallDetail?.outboundCampaign &&
          <div className={styles.callwhisperinnercon}>
            <div className={styles.succesconsec}>
              <div className={styles.calliconsec}>
                <img src={userImg} alt="" className={styles.userImage} />
              </div>
              {!incomingCallDetail.isConference && (
                <div className={styles.userconsec}>
                  {/* <span>
                    {incomingCallDetail.contactDetails?.hasOwnProperty("name")
                      ? (incomingCallDetail?.from !== userDetails?.ext?.toString() || incomingCallDetail.to !== userDetails?.ext?.toString())
                        ? incomingCallDetail?.contactDetails?.name
                        : `${incomingCallDetail?.contactDetails?.name}(me)`
                      : incomingCallDetail.contactDetails?.hasOwnProperty("firstName")
                        ? incomingCallDetail.contactDetails.firstName !== "" && incomingCallDetail.contactDetails.firstName
                        : incomingCallDetail?.from}

                    {/* {incomingCallDetail.bound === "IN" && currentSession?.calledPersonDetails
                    ? `${currentSession?.calledPersonDetails?.firstName} ${currentSession.calledPersonDetails.lastName}`
                    : incomingCallDetail.from} */}
                  {/* </span> */}
                  <label className={styles.phnenumber}>
                    {incomingCallDetail?.contactDetails?.UserName || `${incomingCallDetail?.contactDetails?.firstName} ${incomingCallDetail?.contactDetails?.lastName}`?.trim() || "New Customer"}
                  </label>
                  {/* {incomingCallDetail.agentType === "PRIMARY" ? (
                  <label className={styles.phnenumber}>{incomingCallDetail.from}</label>
                ) : (
                  <label className={styles.phnenumber}>{callDetails.length > 1 ? "Agent Transfer" : queueName ?? ""}</label>
                )} */}
                </div>
              )}
              <div className={styles.supportconsec}>
                <span className={styles.curntsuprt}>{callDetails?.length > 1 ? "Agent Transfer" : incomingCallDetail?.queueName ? incomingCallDetail?.queueName : queueName ?? ""}</span>
                <label className={styles.anstxt}>
                  <span className="icon__Info16" />
                  <span className={styles.timecount}>{incomingCallDetail?.callStatus === "accepted" ? incomingCallDetail?.callduration : incomingCallDetail?.callStatus}</span>
                </label>
              </div>
            </div>
          </div>}

        { incomingCallDetail?.outboundCampaign &&
          <div className={`${styles.callwhisperinnercon} ${styles.campaignkeypad}`}>
            <div className={styles.succesconsec}>
              <div className={styles.calliconsec}>
                <img src={callPopup} alt="" className={styles.userImage} />
              </div>
              {campaign?.incomingCallInfo?.customerName?.length < 26 ?
                <div className={`${styles.userconsec} ${styles.mnonelabel}`}>
                  <label className={styles.phnenumber}>{
                    (campaign?.incomingCallInfo?.customerName?.trim() === "" ||
                      !campaign?.incomingCallInfo?.customerName?.trim()) ? "New Customer"
                      : campaign?.incomingCallInfo?.customerName?.trim()
                  }</label>
                </div>
                :
                <div className={`${styles.userconsec} ${styles.mnonelabel} ${styles.widthfull}`}>
                  <div className="marqueeWrapper">
                    <span className={`${styles.phnenumber} marqueeEffect`}>{
                      (campaign?.incomingCallInfo?.customerName?.trim() === "" ||
                        !campaign?.incomingCallInfo?.customerName?.trim()) ? "New Customer"
                        : campaign?.incomingCallInfo?.customerName?.trim()
                    }</span>
                    <span className={`${styles.phnenumber} marqueeEffect`}>{
                      (campaign?.incomingCallInfo?.customerName?.trim() === "" ||
                        !campaign?.incomingCallInfo?.customerName?.trim()) ? "New Customer"
                        : campaign?.incomingCallInfo?.customerName?.trim()
                    }</span>
                  </div>

                </div>}

              <div className={`${styles.userconsec} ${styles.phnnumcon}`}>
                <label className={styles.phnenumber}>+{campaign?.incomingCallInfo?.customer?.trim() ?? ""}</label>
              </div>
              <div className={styles.supportconsec}>
                <span className={styles.curntsuprt}>Outbound campaign</span>
                <div className={styles.campndcaller} style={{display:"flex", flexDirection:"column", gap:"12px"}}>
                <span className={styles.curntsuprt}>{campaign?.incomingCallInfo?.campaignname && (
                  <h6>{campaign.incomingCallInfo?.campaignname} Campaign</h6>
                )}
                {campaign?.incomingCallInfo?.callerId && (
                  <h6 ><span style={{color:"grey", fontSize:"14px"}}> Caller ID :</span>{campaign?.incomingCallInfo?.callerId} </h6>
                )}
                  {campaign?.incomingCallInfo?.customerUniqueId && (
                  <h6 ><span style={{color:"grey", fontSize:"14px"}}> ID :</span>{campaign?.incomingCallInfo?.customerUniqueId} </h6>
                )}
                </span> 
                  </div>
                
                <span className={styles.curntsuprt}>
                </span>
                {/* <label className={styles.anstxt}>
                  <span className="icon__Info16" />
                  <span className={styles.timecount}>Connecting...</span>
                </label> */}
              </div>
            </div>
          </div>
        }

        {opendtmf && !incomingCallDetail?.outboundCampaign &&
          < DialpadDtmf />}

        <Row className={styles.footerBtn} justify="space-between">
          {incomingCallDetail?.bound !== "IN" && incomingCallDetail?.callStatus !== "accepted" && showCancelDialing && !incomingCallDetail?.outboundCampaign && (
            <Space className="quicktBtn">
              <WtButton className={styles.buttonWhite} name="Cancel" onClick={cancelCall} />
            </Space>
          )}

          {callDetails?.length > 1 && !incomingCallDetail?.outboundCampaign && (
            <Space className="quicktBtn">
              {popUpDetails?.isMergeButton && ((!incomingCallDetail?.holdState) ?
                <div className="tooltip-container mergetooltipcall">

                  <WtButton className={` btn ${styles.buttonWhite} ${styles.buttonWhitemerge}`} name="Merge" onClick={mergeCall} />
                  <span className="tooltip-text">Merge</span>
                </div>
                :
                <div className="tooltip-container mergetooltipcall">
                  <WtButton className={` btn ${styles.buttonWhite} ${styles.buttonWhitemerge} ${styles.disabled}   ${styles.pointerNone}`} name="Merge" />
                  <span className="tooltip-text"> Cannot merge while on hold.</span>
                </div>)}
              {popUpDetails?.isTransferButton && ((!incomingCallDetail.holdState) ?
                <div className="tooltip-container mergetooltipcall">
                  <WtButton className={` btn ${styles.buttonWhite} ${styles.buttonWhitemerge}`} name="Transfer" onClick={TransferCall} />
                  <span className="tooltip-text">Transfer</span>
                </div>
                :
                <div className="tooltip-container mergetooltipcall">
                  <WtButton className={` btn ${styles.buttonWhite} ${styles.buttonWhitemerge} ${styles.disabled}  ${styles.pointerNone}`} name="Transfer" />
                  <span className="tooltip-text">Cannot transfer while on hold.</span>
                </div>
              )}
            </Space>
          )}

          {incomingCallDetail.callStatus === "accepted" && !popUpDetails.mergedCall && callDetails.length === 1 && !incomingCallDetail?.outboundCampaign && (
            <>
              {!incomingCallDetail.muteState ? (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={MuteFunction}>
                    <span className="icon__MikeMute20"></span>
                  </Col>
                  <span className="tooltip-text">Mute</span>
                </div>
              ) : (
                (
                  <div className="tooltip-container callicontooltip">
                    <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={UnMuteFunction}>
                      <span className="icon__MikeMute20"></span>
                    </Col>
                    <span className="tooltip-text">UnMute</span>
                  </div>
                )
              )}
              {!incomingCallDetail.holdState ? (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={HoldFunction}>
                    <span className="icon__CallHold20"></span>
                  </Col>
                  <span className="tooltip-text">Hold</span>
                </div>
              ) : (
                (
                  <div className="tooltip-container callicontooltip">
                    <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={UnHoldFunction}>
                      <span className="icon__CallHold20"></span>
                    </Col>
                    <span className="tooltip-text">UnHold</span>
                  </div>
                )
              )}
              {((incomingCallDetail?.agentType === "PRIMARY" &&  hassAccess('transfer/call') && (!campaign?.incomingCallInfo?.outboundCampaign && !campaign?.userCallInfo) && !(planId === 32 && currentSession?.channelType === 'Call') ) &&
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={openDialPadInCall}>
                    <span className="icon__CallTransferBtn20"></span>
                  </Col>
                  <span className="tooltip-text">Transfer</span>
                </div>
              )}

              {(audioOutputDevices.length > 0 && audioInputDevices.length > 0) ? !changeToSpeaker ? (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={() => toggleAudioOutput(true)}>
                    <span> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                      <path d="M10.0175 0.476563C9.67349 0.476563 9.32179 0.596162 9.02459 0.863063L6.35959 3.25536C5.95479 3.61886 5.42999 3.81986 4.88599 3.81986H3.26379C1.60689 3.81986 0.263794 5.16316 0.263794 6.81986V9.17996C0.263794 10.837 1.60689 12.18 3.26379 12.18H4.88599C5.43009 12.18 5.95479 12.3809 6.35959 12.7445L9.02459 15.1368C9.32199 15.4039 9.67339 15.5235 10.0175 15.5235C10.7907 15.5235 11.5267 14.9185 11.5267 14.0206V1.97946C11.5267 1.08126 10.7909 0.476263 10.0175 0.476563ZM10.0265 14.0205L7.36169 11.6284C6.68069 11.0168 5.80139 10.6799 4.88589 10.6799H3.26369C2.43659 10.6799 1.76369 10.007 1.76369 9.17986V6.81976C1.76369 5.99266 2.43659 5.31976 3.26369 5.31976H4.88589C5.80139 5.31976 6.68079 4.98286 7.36159 4.37156L10.0266 1.98016L10.0265 14.0205Z" fill="#757676" />
                      <path d="M14.7885 4.30566C14.4931 4.01756 14.0185 4.02046 13.728 4.31636C13.438 4.61226 13.4428 5.08786 13.7387 5.37786C14.4472 6.07126 14.8393 6.99696 14.8437 7.98336C14.8486 8.97746 14.4584 9.91696 13.746 10.627C13.453 10.92 13.4521 11.3946 13.745 11.6875C13.8915 11.835 14.0834 11.9082 14.2758 11.9082C14.4672 11.9082 14.6591 11.835 14.8056 11.6894C15.8036 10.6933 16.35 9.37486 16.3437 7.97646C16.3378 6.58586 15.7851 5.28316 14.7885 4.30566Z" fill="#757676" />
                      <path d="M17.2953 2.20016C16.9994 1.91106 16.5248 1.91496 16.2348 2.21186C15.9448 2.50776 15.9496 2.98236 16.2455 3.27236C17.5224 4.52236 18.2299 6.19126 18.2382 7.96966C18.246 9.76166 17.5439 11.4531 16.2611 12.7324C15.9681 13.0254 15.9672 13.5 16.2596 13.7929C16.4066 13.9404 16.5985 14.0136 16.7908 14.0136C16.9822 14.0136 17.1741 13.9404 17.3206 13.7948C18.889 12.2303 19.7478 10.1591 19.7376 7.96276C19.7278 5.78016 18.8607 3.73436 17.2953 2.20016Z" fill="#757676" />
                    </svg></span>
                  </Col>
                  <span className="tooltip-text">Speaker on</span>
                </div>


              ) : (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={() => toggleAudioOutput(false)}>
                    <span> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                      <path d="M10.0175 0.476563C9.67349 0.476563 9.32179 0.596162 9.02459 0.863063L6.35959 3.25536C5.95479 3.61886 5.42999 3.81986 4.88599 3.81986H3.26379C1.60689 3.81986 0.263794 5.16316 0.263794 6.81986V9.17996C0.263794 10.837 1.60689 12.18 3.26379 12.18H4.88599C5.43009 12.18 5.95479 12.3809 6.35959 12.7445L9.02459 15.1368C9.32199 15.4039 9.67339 15.5235 10.0175 15.5235C10.7907 15.5235 11.5267 14.9185 11.5267 14.0206V1.97946C11.5267 1.08126 10.7909 0.476263 10.0175 0.476563ZM10.0265 14.0205L7.36169 11.6284C6.68069 11.0168 5.80139 10.6799 4.88589 10.6799H3.26369C2.43659 10.6799 1.76369 10.007 1.76369 9.17986V6.81976C1.76369 5.99266 2.43659 5.31976 3.26369 5.31976H4.88589C5.80139 5.31976 6.68079 4.98286 7.36159 4.37156L10.0266 1.98016L10.0265 14.0205Z" fill="#757676" />
                      <path d="M14.7885 4.30566C14.4931 4.01756 14.0185 4.02046 13.728 4.31636C13.438 4.61226 13.4428 5.08786 13.7387 5.37786C14.4472 6.07126 14.8393 6.99696 14.8437 7.98336C14.8486 8.97746 14.4584 9.91696 13.746 10.627C13.453 10.92 13.4521 11.3946 13.745 11.6875C13.8915 11.835 14.0834 11.9082 14.2758 11.9082C14.4672 11.9082 14.6591 11.835 14.8056 11.6894C15.8036 10.6933 16.35 9.37486 16.3437 7.97646C16.3378 6.58586 15.7851 5.28316 14.7885 4.30566Z" fill="#757676" />
                      <path d="M17.2953 2.20016C16.9994 1.91106 16.5248 1.91496 16.2348 2.21186C15.9448 2.50776 15.9496 2.98236 16.2455 3.27236C17.5224 4.52236 18.2299 6.19126 18.2382 7.96966C18.246 9.76166 17.5439 11.4531 16.2611 12.7324C15.9681 13.0254 15.9672 13.5 16.2596 13.7929C16.4066 13.9404 16.5985 14.0136 16.7908 14.0136C16.9822 14.0136 17.1741 13.9404 17.3206 13.7948C18.889 12.2303 19.7478 10.1591 19.7376 7.96276C19.7278 5.78016 18.8607 3.73436 17.2953 2.20016Z" fill="#757676" />
                    </svg></span>
                  </Col>
                  <span className="tooltip-text">Speaker off</span>
                </div>
              ) : (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`}>
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path d="M11.3727 4.98335V8.89355L12.8727 10.4034V4.98345C12.8727 4.08355 12.1427 3.47345 11.3727 3.47345C11.0227 3.47345 10.6727 3.59355 10.3727 3.86335L8.25256 5.76345L9.31256 6.83355L11.3727 4.98335Z" fill="#757676" />
                        <path d="M16.1927 10.9834C16.2027 11.7434 15.9727 12.4734 15.5427 13.0835L16.6127 14.1533C17.3227 13.2434 17.7027 12.1333 17.6927 10.9734C17.6927 9.58345 17.1327 8.28345 16.1427 7.30345C15.8427 7.01345 15.3727 7.02345 15.0827 7.31345C14.7927 7.61325 14.7927 8.08345 15.0927 8.37355C15.8027 9.07355 16.1927 9.99335 16.1927 10.9834Z" fill="#757676" />
                        <path d="M19.5927 10.9734C19.5927 12.6235 18.9927 14.1934 17.8827 15.4334L18.9427 16.5035C20.3427 14.9835 21.1027 13.0235 21.0927 10.9635C21.0827 8.78355 20.2127 6.73345 18.6427 5.20345C18.3527 4.91365 17.8727 4.91365 17.5827 5.21345C17.2927 5.50345 17.3027 5.98345 17.5927 6.27355C18.8727 7.52355 19.5827 9.19325 19.5927 10.9734Z" fill="#757676" />
                        <path d="M2.18846 1.11325C1.89596 0.819354 1.42136 0.819354 1.12796 1.11125C0.834564 1.40315 0.833564 1.87785 1.12596 2.17175L5.75856 6.82335H4.61266C2.95266 6.82335 1.61266 8.16345 1.61266 9.82335V12.1833C1.61266 13.8334 2.95266 15.1833 4.61266 15.1833H6.23266C6.78266 15.1833 7.30266 15.3833 7.71266 15.7434L10.3727 18.1333C10.6727 18.4033 11.0227 18.5234 11.3727 18.5234C12.1427 18.5234 12.8727 17.9233 12.8727 17.0234V13.9668L19.7642 20.8867C19.9107 21.0342 20.1031 21.1074 20.2954 21.1074C20.4868 21.1074 20.6782 21.0342 20.8247 20.8886C21.1182 20.5966 21.1191 20.122 20.8267 19.8281L2.18846 1.11325ZM11.3727 17.0235L8.71266 14.6334C8.03266 14.0135 7.15266 13.6834 6.23266 13.6834H4.61266C3.78266 13.6834 3.11266 13.0035 3.11266 12.1834V9.82345C3.11266 8.99335 3.78266 8.32345 4.61266 8.32345H6.23266C6.53706 8.32345 6.84126 8.28385 7.13606 8.20655L11.3727 12.4608V17.0235Z" fill="#757676" />
                      </svg>
                    </span>
                  </Col>
                  <span className="tooltip-text">No Speaker</span>
                </div>
              )
              }



              <Col span={24}>
                <Space className="quicktBtn">
                  <WtButton className={`${styles.buttonWhite} ${styles.buttonEndCall}`} name="Hang up" onClick={endCall} />
                </Space>
              </Col>

              {/* {incomingCallDetail.agentType === "PRIMARY" ? (
                <Col span={6} className={`${styles.actionIcons} ${styles.endCall}`}>
                  <span className="icon__TransferEndWhite20" onClick={endCall}></span>
                </Col>
              ) : (
                <Col span={24}>
                  <Space className="quicktBtn">
                    <WtButton className={`${styles.buttonWhite} ${styles.buttonEndCall}`} name="Hang up" onClick={endCall} />
                  </Space>
                </Col>
              )} */}
            </>
          )}

          {/* {incomingCallDetail.callStatus === "accepted" && !popUpDetails.mergedCall && callDetails.length > 1 && ( */}
          {incomingCallDetail.callStatus === "accepted" && popUpDetails.isMergeButton && !incomingCallDetail?.outboundCampaign && (
            <>
              {!incomingCallDetail.muteState ? (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={MuteFunction}>
                    <span className="icon__MikeMute20"></span>
                  </Col>
                  <span className="tooltip-text">Mute</span>
                </div>
              ) : (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={UnMuteFunction}>
                    <span className="icon__MikeMute20"></span>
                  </Col>
                  <span className="tooltip-text">UnMute</span>
                </div>
              )}
              {/* {!incomingCallDetail.holdState ? (
                <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`}>
                  <span className="icon__CallHold20"></span>
                </Col>
              ) : (
                <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`}>
                  <span className="icon__CallHold20"></span>
                </Col>
              )} */}
              {!incomingCallDetail.holdState ? (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons}`} onClick={HoldFunction}>
                    <span className="icon__CallHold20"></span>
                  </Col>
                  <span className="tooltip-text">Hold</span>
                </div>
              ) : (
                <div className="tooltip-container callicontooltip">
                  <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`}>
                    <span className="icon__CallHold20" onClick={UnHoldFunction}></span>
                  </Col>
                  <span className="tooltip-text">UnHold</span>
                </div>
              )}
              {incomingCallDetail.agentType === "PRIMARY" && (
                <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`}>
                  <span className="icon__CallTransferBtn20"></span>
                </Col>
              )}
              <Col span={6} className={`${styles.actionIcons} ${styles.endCall}`}>
                <span className="icon__TransferEndWhite20" onClick={endCall}></span>
              </Col>
            </>
          )}

          {/* {incomingCallDetail.callStatus === "accepted" && popUpDetails.mergedCall && ( */}
          {incomingCallDetail.callStatus === "accepted" && popUpDetails.mergedCall && !popUpDetails.isMergeButton && !incomingCallDetail?.outboundCampaign && (
            <>
              <Row className={`${styles.footerBtn} ${styles.footerLeavecallBtn}`} justify="space-between">

                <div className={`${styles.iconSection}`}>
                  {!incomingCallDetail.muteState ? (
                    <div className="tooltip-container callicontooltip">
                      <Col span={6} className={`${styles.actionIcons}`} onClick={MuteFunction}>
                        <span className="icon__MikeMute20"></span>
                      </Col>
                      <span className="tooltip-text">Mute</span>
                    </div>
                  ) : (
                    <div className="tooltip-container callicontooltip">
                      <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={UnMuteFunction}>
                        <span className="icon__MikeMute20"></span>
                      </Col>
                      <span className="tooltip-text">UnMute</span>
                    </div>
                  )}
                  {!incomingCallDetail.holdState ? (
                    <div className="tooltip-container callicontooltip">
                      <Col span={6} className={`${styles.actionIcons}`} onClick={HoldFunction}>
                        <span className="icon__CallHold20"></span>
                      </Col>
                      <span className="tooltip-text">Hold</span>
                    </div>
                  ) : (
                    <div className="tooltip-container callicontooltip">
                      <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`}>
                        <span className="icon__CallHold20" onClick={UnHoldFunction}></span>
                      </Col>
                      <span className="tooltip-text">UnHold</span>
                    </div>
                  )}
                  {(audioOutputDevices.length > 0 && audioInputDevices.length > 0) ? !changeToSpeaker ? (
                    <div className="tooltip-container callicontooltip">
                      <Col span={6} className={`${styles.actionIcons}`} onClick={() => toggleAudioOutput(true)}>
                        <span> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                          <path d="M10.0175 0.476563C9.67349 0.476563 9.32179 0.596162 9.02459 0.863063L6.35959 3.25536C5.95479 3.61886 5.42999 3.81986 4.88599 3.81986H3.26379C1.60689 3.81986 0.263794 5.16316 0.263794 6.81986V9.17996C0.263794 10.837 1.60689 12.18 3.26379 12.18H4.88599C5.43009 12.18 5.95479 12.3809 6.35959 12.7445L9.02459 15.1368C9.32199 15.4039 9.67339 15.5235 10.0175 15.5235C10.7907 15.5235 11.5267 14.9185 11.5267 14.0206V1.97946C11.5267 1.08126 10.7909 0.476263 10.0175 0.476563ZM10.0265 14.0205L7.36169 11.6284C6.68069 11.0168 5.80139 10.6799 4.88589 10.6799H3.26369C2.43659 10.6799 1.76369 10.007 1.76369 9.17986V6.81976C1.76369 5.99266 2.43659 5.31976 3.26369 5.31976H4.88589C5.80139 5.31976 6.68079 4.98286 7.36159 4.37156L10.0266 1.98016L10.0265 14.0205Z" fill="#757676" />
                          <path d="M14.7885 4.30566C14.4931 4.01756 14.0185 4.02046 13.728 4.31636C13.438 4.61226 13.4428 5.08786 13.7387 5.37786C14.4472 6.07126 14.8393 6.99696 14.8437 7.98336C14.8486 8.97746 14.4584 9.91696 13.746 10.627C13.453 10.92 13.4521 11.3946 13.745 11.6875C13.8915 11.835 14.0834 11.9082 14.2758 11.9082C14.4672 11.9082 14.6591 11.835 14.8056 11.6894C15.8036 10.6933 16.35 9.37486 16.3437 7.97646C16.3378 6.58586 15.7851 5.28316 14.7885 4.30566Z" fill="#757676" />
                          <path d="M17.2953 2.20016C16.9994 1.91106 16.5248 1.91496 16.2348 2.21186C15.9448 2.50776 15.9496 2.98236 16.2455 3.27236C17.5224 4.52236 18.2299 6.19126 18.2382 7.96966C18.246 9.76166 17.5439 11.4531 16.2611 12.7324C15.9681 13.0254 15.9672 13.5 16.2596 13.7929C16.4066 13.9404 16.5985 14.0136 16.7908 14.0136C16.9822 14.0136 17.1741 13.9404 17.3206 13.7948C18.889 12.2303 19.7478 10.1591 19.7376 7.96276C19.7278 5.78016 18.8607 3.73436 17.2953 2.20016Z" fill="#757676" />
                        </svg></span>
                      </Col>
                      <span className="tooltip-text">Speaker</span>
                    </div>
                  ) : (
                    <div className="tooltip-container callicontooltip">

                      <Col span={6} className={`${styles.actionIcons} ${styles.disabled}`} onClick={() => toggleAudioOutput(false)}>
                        <span> <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                          <path d="M10.0175 0.476563C9.67349 0.476563 9.32179 0.596162 9.02459 0.863063L6.35959 3.25536C5.95479 3.61886 5.42999 3.81986 4.88599 3.81986H3.26379C1.60689 3.81986 0.263794 5.16316 0.263794 6.81986V9.17996C0.263794 10.837 1.60689 12.18 3.26379 12.18H4.88599C5.43009 12.18 5.95479 12.3809 6.35959 12.7445L9.02459 15.1368C9.32199 15.4039 9.67339 15.5235 10.0175 15.5235C10.7907 15.5235 11.5267 14.9185 11.5267 14.0206V1.97946C11.5267 1.08126 10.7909 0.476263 10.0175 0.476563ZM10.0265 14.0205L7.36169 11.6284C6.68069 11.0168 5.80139 10.6799 4.88589 10.6799H3.26369C2.43659 10.6799 1.76369 10.007 1.76369 9.17986V6.81976C1.76369 5.99266 2.43659 5.31976 3.26369 5.31976H4.88589C5.80139 5.31976 6.68079 4.98286 7.36159 4.37156L10.0266 1.98016L10.0265 14.0205Z" fill="#757676" />
                          <path d="M14.7885 4.30566C14.4931 4.01756 14.0185 4.02046 13.728 4.31636C13.438 4.61226 13.4428 5.08786 13.7387 5.37786C14.4472 6.07126 14.8393 6.99696 14.8437 7.98336C14.8486 8.97746 14.4584 9.91696 13.746 10.627C13.453 10.92 13.4521 11.3946 13.745 11.6875C13.8915 11.835 14.0834 11.9082 14.2758 11.9082C14.4672 11.9082 14.6591 11.835 14.8056 11.6894C15.8036 10.6933 16.35 9.37486 16.3437 7.97646C16.3378 6.58586 15.7851 5.28316 14.7885 4.30566Z" fill="#757676" />
                          <path d="M17.2953 2.20016C16.9994 1.91106 16.5248 1.91496 16.2348 2.21186C15.9448 2.50776 15.9496 2.98236 16.2455 3.27236C17.5224 4.52236 18.2299 6.19126 18.2382 7.96966C18.246 9.76166 17.5439 11.4531 16.2611 12.7324C15.9681 13.0254 15.9672 13.5 16.2596 13.7929C16.4066 13.9404 16.5985 14.0136 16.7908 14.0136C16.9822 14.0136 17.1741 13.9404 17.3206 13.7948C18.889 12.2303 19.7478 10.1591 19.7376 7.96276C19.7278 5.78016 18.8607 3.73436 17.2953 2.20016Z" fill="#757676" />
                        </svg></span>
                      </Col>
                      <span className="tooltip-text">Microphone</span>
                    </div>
                  ) : (
                    <div className="tooltip-container callicontooltip">

                      <Col span={6} className={`${styles.actionIcons}`}>
                        <span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                            <path d="M11.3727 4.98335V8.89355L12.8727 10.4034V4.98345C12.8727 4.08355 12.1427 3.47345 11.3727 3.47345C11.0227 3.47345 10.6727 3.59355 10.3727 3.86335L8.25256 5.76345L9.31256 6.83355L11.3727 4.98335Z" fill="#757676" />
                            <path d="M16.1927 10.9834C16.2027 11.7434 15.9727 12.4734 15.5427 13.0835L16.6127 14.1533C17.3227 13.2434 17.7027 12.1333 17.6927 10.9734C17.6927 9.58345 17.1327 8.28345 16.1427 7.30345C15.8427 7.01345 15.3727 7.02345 15.0827 7.31345C14.7927 7.61325 14.7927 8.08345 15.0927 8.37355C15.8027 9.07355 16.1927 9.99335 16.1927 10.9834Z" fill="#757676" />
                            <path d="M19.5927 10.9734C19.5927 12.6235 18.9927 14.1934 17.8827 15.4334L18.9427 16.5035C20.3427 14.9835 21.1027 13.0235 21.0927 10.9635C21.0827 8.78355 20.2127 6.73345 18.6427 5.20345C18.3527 4.91365 17.8727 4.91365 17.5827 5.21345C17.2927 5.50345 17.3027 5.98345 17.5927 6.27355C18.8727 7.52355 19.5827 9.19325 19.5927 10.9734Z" fill="#757676" />
                            <path d="M2.18846 1.11325C1.89596 0.819354 1.42136 0.819354 1.12796 1.11125C0.834564 1.40315 0.833564 1.87785 1.12596 2.17175L5.75856 6.82335H4.61266C2.95266 6.82335 1.61266 8.16345 1.61266 9.82335V12.1833C1.61266 13.8334 2.95266 15.1833 4.61266 15.1833H6.23266C6.78266 15.1833 7.30266 15.3833 7.71266 15.7434L10.3727 18.1333C10.6727 18.4033 11.0227 18.5234 11.3727 18.5234C12.1427 18.5234 12.8727 17.9233 12.8727 17.0234V13.9668L19.7642 20.8867C19.9107 21.0342 20.1031 21.1074 20.2954 21.1074C20.4868 21.1074 20.6782 21.0342 20.8247 20.8886C21.1182 20.5966 21.1191 20.122 20.8267 19.8281L2.18846 1.11325ZM11.3727 17.0235L8.71266 14.6334C8.03266 14.0135 7.15266 13.6834 6.23266 13.6834H4.61266C3.78266 13.6834 3.11266 13.0035 3.11266 12.1834V9.82345C3.11266 8.99335 3.78266 8.32345 4.61266 8.32345H6.23266C6.53706 8.32345 6.84126 8.28385 7.13606 8.20655L11.3727 12.4608V17.0235Z" fill="#757676" />
                          </svg>
                        </span>
                      </Col>
                      <span className="tooltip-text">Speaker</span>
                    </div>
                  )
                  }
                </div>
                <div className={`${styles.buttonSection}`}>
                  {incomingCallDetail.agentType !== "PRIMARY" && (
                    <Col span={12} className={`${styles.actionIcons} ${styles.leaveCall}`}>
                      <span onClick={leaveCallSecondary}>Leave Call</span>
                    </Col>
                  )}
                  {incomingCallDetail.agentType === "PRIMARY" && (
                    <Col span={12} className={`${styles.actionIcons} ${styles.leaveCall}`}>
                      <span onClick={leaveCallFromGroup}>Leave Call</span>
                    </Col>
                  )}
                  {incomingCallDetail.agentType === "PRIMARY" && (
                    <Col span={24}>
                      <Space className="quicktBtn">
                        <WtButton className={`${styles.buttonWhite} ${styles.buttonEndCall}`} name="End for all" onClick={endForAll} />
                      </Space>
                    </Col>
                  )}
                </div>
              </Row>
            </>
          )}
        </Row>
      </div>
    </>

  );
}
export default AgentCallAttended;
